import {InjectionToken} from "@angular/core";
import {TIntTableColumnsLimiterData} from "./types";

export const INT_TABLE_COLUMNS_LIMITER_DATA_LIST_TOKEN = new InjectionToken<TIntTableColumnsLimiterData<unknown>>(
  'INT_TABLE_COLUMNS_LIMITER_DATA_LIST_TOKEN', {
  factory() {
    return [];
  }
});

export const INT_TABLE_COLUMNS_LIMITER_DATA_EXCLUDE_ON_LOAD_LIST_TOKEN
  = new InjectionToken<TIntTableColumnsLimiterData<unknown> | null>(
    'INT_TABLE_COLUMNS_LIMITER_DATA_EXCLUDE_ON_LOAD_LIST_TOKEN', {
  factory() {
    return []
  }
});

export const INT_TABLE_COLUMNS_LIMITER_DATA_EXCLUDE_ON_LOAD_FORMATTER
  = new InjectionToken<(list: TIntTableColumnsLimiterData<unknown>, excludeList: TIntTableColumnsLimiterData<unknown>) => TIntTableColumnsLimiterData<unknown>>(
    'INT_TABLE_COLUMNS_LIMITER_DATA_EXCLUDE_ON_LOAD_FORMATTER', {
  factory() {
    return (list: TIntTableColumnsLimiterData<unknown>) => list;
  }
});

export const INT_TABLE_COLUMNS_LIMITER_DATA_FORMATTER = new InjectionToken<(list: TIntTableColumnsLimiterData<unknown>) => TIntTableColumnsLimiterData<unknown>>('INT_TABLE_COLUMNS_LIMITER_DATA_FORMATTER', {
  factory() {
    return (list: TIntTableColumnsLimiterData<unknown>) => list;
  }
});

export const INT_TABLE_COLUMNS_LIMITER_DISPLAYED_PROP
  = new InjectionToken<string>('INT_TABLE_COLUMNS_LIMITER_DISPLAYED_PROP', {
    factory() {
      return 'label'
    }
});

export const INT_TABLE_COLUMNS_LIMITER_VALUE_PROP
  = new InjectionToken<string>('INT_TABLE_COLUMNS_LIMITER_VALUE_PROP', {
  factory() {
    return 'fieldName'
  }
});
